module.exports = __webpack_public_path__ + "img/MHU_5.ad065854.jpg";